/* eslint-disable react/no-array-index-key */
import React, { PureComponent } from 'react';
import { Collapse } from 'reactstrap';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import NotificationsIcon from 'mdi-react/NotificationsIcon';
import { useBasicAuth } from '../../../shared/components/auth/withBasicAuth';
import { environment } from '../../environment';
import { util } from "../../../shared/util";

let img = `${process.env.PUBLIC_URL}/img/topbar/coffee_`;

class TopbarNotification extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      collapse: false,
      showAlert: false,
      showAlertOK: true,
      intervalId: 0,
      notifications: [],
      orders: []
    };

    this.markAllAsReceived = this.markAllAsReceived.bind(this);
  }

  toggle = () => {
    this.setState(prevState => ({ collapse: !prevState.collapse }));
  };

  load(){
    if(useBasicAuth.checkTokenExists()){
      if(environment.isAdmin()){
        //this.loadOrderByUser("admin"); this.buildNotifications(data);
      }else{
        //this.loadOrderByUser("user"); this.buildNotifications(data);
      }
    }else{
      clearInterval(this.state.intervalId);
    }
  }

  init(){
    const loadBounded = this.load.bind(this);
    if(this.state.intervalId === 0){
      let intervalId = setInterval(loadBounded, 20000);
      this.setState({intervalId: intervalId}, () => {
        this.load();
      });
    }
  }

  buildNotifications(data){
    let notifications = [];
    let orders = [];
    let showAlert = false;
    let total = 0;

    let qty = 0;
    let qtyMedida = '';
    let product = '';

    if(data !== null && data !== undefined && data.length > 0){
      total = data.length;
      for(let i = 0; i < total; i++){
        if(data[i].status === "ORDERED"){
          showAlert = true;
          qty = data[i].qty;
          qtyMedida = data[i].product.qtyMedida;

          if(qtyMedida === "kg"){
            product = qty + ' ' + qtyMedida;
          }else{
            product = (qty > 1) ? qty + ' ' + qtyMedida + 's' : qty + ' ' + qtyMedida;
          }
          
          let item = {
            ava: img + data[i].status + '.png',
            name: data[i].user.firstName + " " + data[i].user.lastName,
            message: product + " " + this.props.t('forms.of') + " " + data[i].product.name + " " + util.currencyMask(data[i].price),
            code: data[i].code,
            date: util.formatDateHoraToString(data[i].createdAt, ""),
            color: "#e7f3fd",
          }
          if(notifications.length < 5){
            notifications.push(item);
          }
          orders.push(data[i]);
        }
      }
      if(notifications.length < 5){
        for(let i = 0; i < total; i++){
          if(data[i].status !== "ORDERED"){
            qty = data[i].qty;
            qtyMedida = data[i].product.qtyMedida;
  
            if(qtyMedida === "kg"){
              product = qty + ' ' + qtyMedida;
            }else{
              product = (qty > 1) ? qty + ' ' + qtyMedida + 's' : qty + ' ' + qtyMedida;
            }

            let item = {
              ava: img + data[i].status + '.png',
              name: data[i].user.firstName + " " + data[i].user.lastName,
              message: product + " " + this.props.t('forms.of') + " " + data[i].product.name + " " + util.currencyMask(data[i].product.price),
              code: data[i].code,
              date: util.formatDateHoraToString(data[i].createdAt, ""),
              color: null,
            }
            if(notifications.length < 5){
              notifications.push(item);
            }
          }
        }
      }
      if(showAlert && this.state.showAlertOK){
        this.props.show('danger', this.props.t('notifications.dangerTitle'), this.props.t('notifications.dangerMessage'), '');
        this.setState({ notifications, orders, showAlert, showAlertOK: false });
      }else{
        this.setState({ notifications, orders, showAlert });
      }
    }
  }

  markAllAsReceived = () => {
    // const total = this.state.orders.length;
    // let order = {}
    // for(let i = 0; i < total; i++){
    //   order = this.state.orders[i];
    //   order.status = "RECEIVED";
    //   updateOrder(order)
    //   .then(obj => {
    //     if((i+1) === total){
    //       this.load();
    //     }
    //   });
    // }
    // this.setState({ showAlert: false, showAlertOK: true });
  }

  handleSubmit(code) {
    useBasicAuth.redirectSearch(code);
  }

  componentDidMount() {
    //this.init();
  }

  render() {
    const { collapse } = this.state;
    const { t } = this.props;

    // MCCOSTA: Notifications

    let iconAlert = "";
    if(this.state.showAlert){
      iconAlert = <div className="topbar__btn-new-label"><div /></div>
    }

    return (
      <div className="topbar__collapse">
        <style>
          {`
            .hover-div {
              background: #FFFFFF;
            }

            .hover-div:hover {
              background: #F8F8F8;
            }
          `}
        </style>
        <button className="topbar__btn topbar__btn--mail topbar__btn--new" type="button" onClick={this.toggle}>
          <NotificationsIcon />
          {iconAlert}
        </button>
        {collapse && <button className="topbar__back" type="button" onClick={this.toggle} />}
        <Collapse
          isOpen={collapse}
          className="topbar__collapse-content topbar__collapse-content--notify"
        >
          <div className="topbar__collapse-title-wrap">
            <p className="topbar__collapse-title">{t('notifications.title')}</p>
            <button className="topbar__collapse-button" type="button" onClick={this.markAllAsReceived}>
              {t('notifications.markAllAsReceived')}
            </button>
          </div>
          {this.state.notifications.map((notification, index) => (
            <div className="topbar__collapse-item hover-div" key={index} 
              onClick={() => this.handleSubmit(notification.code)}
              style={{cursor: "pointer", backgroundColor: notification.color !== null ? notification.color : null }}>
              <div className="topbar__collapse-img-wrap">
                <img className="topbar__collapse-img" src={notification.ava} alt="" />
              </div>
              <p className="topbar__collapse-message">
                <span className="topbar__collapse-name">{notification.name}</span>
                <br />
                {notification.message}
              </p>
              <p className="topbar__collapse-date">{notification.date}</p>
            </div>
          ))}
          <Link className="topbar__collapse-link" to="/forms/order" onClick={this.toggle}>
            {t('notifications.seeAllOrders')}
          </Link>
        </Collapse>
      </div>
    );
  }
}

export default withTranslation('common')(TopbarNotification);